import React, { SyntheticEvent, useState } from 'react'
import { Dropdown, Input } from 'semantic-ui-react'
import type { DropdownProps, InputOnChangeData } from 'semantic-ui-react'
import { useCookies } from 'react-cookie'
import { useRouter } from 'next/router'
import { get } from 'lodash'

import RequestService from 'services/request.service'

import Editor from 'components/formElements/richText/Editor'

import { humanReadableObjectToDropdown } from 'utils/DropdownConversions'

import { emptyTextArea } from 'types/editor'
import { COMMENT_TYPES } from 'types/comments'
import { ROLES } from 'types/user'

import styles from './newThreadForm.module.scss'

const DESCRIPTION_COMMENTS = [COMMENT_TYPES.News, COMMENT_TYPES.Features, COMMENT_TYPES.Contest]

type Props = {
  category: string
  section: string
}

const NewThreadForm = ({ category, section }: Props) => {
  const router = useRouter()

  const [threadType, setThreadType] = useState(0)
  const [featured, setFeatured] = useState('')
  const [description, setDescription] = useState('')
  const [tag, setTag] = useState('')
  const [editorState, setEditorState] = useState(emptyTextArea)
  const [title, setTitle] = useState('')

  const [{ tbR: roles = [] }] = useCookies(['tbR'])

  // If a thread get's a description or not (internal posts only)
  const descriptionWorthy = DESCRIPTION_COMMENTS.includes(threadType)

  const handleTitileUpdate = (_e: any, { value }: any) => setTitle(value)

  const handleSubmit = () => {
    const body: any = { title, section, category, text: editorState }

    // Cleaning up the request body to make the API happy
    // TODO - make the api validations accept anything and ignore everything else based on the threadType
    if (threadType) body.type = threadType
    if (featured) body.featured = featured
    if (description) body.description = description
    if (tag) body.tag = tag

    return RequestService.post('/api/comments/createThread/', body)
      .then(res => {
        if (threadType == COMMENT_TYPES.Contest) router.push(`/contest/${res.id}`)
        else router.push(`/forum/thread/${res.id}`)
      })
      .catch(err => RequestService.createToast(get(err, 'non_field_errors[0]', 'Unable to create thread')))
  }

  return (
    <div className={styles.container}>
      <Input className={styles.input} value={title} onChange={handleTitileUpdate} placeholder="Thread Title" />
      {roles.includes(ROLES.MOD) && (
        <Dropdown
          fluid
          selection
          className={styles.input}
          value={threadType}
          onChange={(_e: SyntheticEvent, { value }: DropdownProps) => setThreadType(Number(value))}
          options={humanReadableObjectToDropdown(COMMENT_TYPES)}
        />
      )}
      {roles.includes(ROLES.MOD) && descriptionWorthy && (
        <>
          <Input
            className={styles.input}
            value={featured}
            onChange={(_e: SyntheticEvent, { value }: InputOnChangeData) => setFeatured(value)}
            placeholder="Image Url for Featured Image"
          />
          <Input
            className={styles.input}
            value={description}
            onChange={(_e: SyntheticEvent, { value }: InputOnChangeData) => setDescription(value)}
            placeholder="Short description of the post..."
          />
          <Input
            className={styles.input}
            value={tag}
            onChange={(_e: SyntheticEvent, { value }: InputOnChangeData) => setTag(value)}
            placeholder="Tag this post (changelog, competition, news)..."
          />
        </>
      )}
      <Editor
        placeholder="Thread content..."
        value={editorState}
        onChange={setEditorState}
        onSubmit={handleSubmit}
        captcha
      />
    </div>
  )
}

export default NewThreadForm
